module.exports = __webpack_public_path__ + "img/desktop-white.9c65f270.png";